export const LOGIN_EMAIL_PLACEHOLDER = 'Email Address';
export const loginValidationRules = {
  email: {
    required: 'Email is required',
    pattern: {
      value: /^[\w+.-]+@([\w-]+\.)+[\w-]{2,4}$/,
      message: 'Invalid email address',
    },
  },
  password: {
    required: 'Password is required',
  },
};
